// Matches the Similaris visual language (Public Sans + crimson/gold palette)
export const theme = {
  colors: {
    background: 'hsl(0, 0%, 100%)',
    foreground: 'hsl(213, 100%, 12%)',
    card: 'hsl(0, 0%, 100%)',
    cardForeground: 'hsl(213, 100%, 12%)',
    primary: 'hsl(216, 100%, 27%)',
    primaryForeground: 'hsl(0, 0%, 100%)',
    secondary: 'hsl(0, 100%, 25%)',
    secondaryForeground: 'hsl(0, 0%, 100%)',
    crimson: 'hsl(348, 91%, 47%)',
    crimsonForeground: 'hsl(0, 0%, 100%)',
    maroon: 'hsl(0, 100%, 25%)',
    maroonForeground: 'hsl(0, 0%, 100%)',
    gold: 'hsl(43, 96%, 56%)',
    goldForeground: 'hsl(213, 100%, 12%)',
    muted: 'hsl(210, 40%, 96%)',
    mutedForeground: 'hsl(215, 16%, 47%)',
    border: 'rgba(0, 48, 135, 0.08)',
  },
  radius: '20px',
  radiusSm: '20px',
  shadowCard:
    '0 0 0 1px rgba(0,48,135,0.05), 0 4px 6px -1px rgba(0,0,0,0.05), 0 10px 15px -3px rgba(0,0,0,0.03)',
  shadowCardHover:
    '0 0 0 1px rgba(0,48,135,0.08), 0 8px 12px -2px rgba(0,0,0,0.08), 0 16px 24px -4px rgba(0,0,0,0.05)',
  fontFamily: "'Public Sans', system-ui, sans-serif",
  /** Match Similaris: wide content band, not a narrow max-width column */
  containerWidth: '90%',
  containerMaxWidth: 'none',
  containerPadding: '1rem',
  containerPaddingMobile: '1rem',
  fontClamp: {
    xs: 'clamp(0.75rem, 0.7rem + 0.25vw, 0.9375rem)',
    sm: 'clamp(0.875rem, 0.8rem + 0.35vw, 1.0625rem)',
    base: 'clamp(1rem, 0.9rem + 0.5vw, 1.25rem)',
    lg: 'clamp(1.125rem, 1rem + 0.6vw, 1.4375rem)',
    xl: 'clamp(1.25rem, 1.1rem + 0.75vw, 1.625rem)',
    '2xl': 'clamp(1.5rem, 1.25rem + 1.25vw, 2rem)',
    '3xl': 'clamp(1.875rem, 1.5rem + 1.75vw, 2.5rem)',
    hero: 'clamp(2rem, 1.5rem + 2.5vw, 3.25rem)',
  },
};

